import { userService } from "../_services/user.service";
import exceptionHandler from "./exceptionHandler";
import { toast } from "react-toastify";
import { api } from "../_services/api.service";
import Compressor from "compressorjs";

const _doUploadImage = (base64File, filename, resolve) => {
  const currentUser = userService.getLoggedInUser();
  let promise = api
    .uploadImage(currentUser.userId, base64File, filename)
    .then((url) => {
      toast("Image upload success", {
        autoClose: 3000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: false,
      });

      resolve(url)
    })
    .catch(exceptionHandler);

  return promise;
};

const uploadImage = async (file) => {
  // check size (in bytes)
  if (file.size / 1000000 > 5) {
    // allow max 5 MB
    showErrorToast("Image size is too big!");
    return "";
  }

  const filename = file.name;

  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.5,
      maxWidth: 200, // Set max width to resize
      maxHeight: 200, // Set max height to resize
      success: (resizedImage) => {
        const reader = new FileReader();
        reader.readAsDataURL(resizedImage);
        reader.onloadend = async () => {
          await _doUploadImage(reader.result.split(',')[1], filename, resolve);
        };
      },
    });
  });

  // let c = new Compress();
  // const resizedImage = await c.compress([file], {
  //   size: 1,
  //   quality: 0.5,
  //   resize: true
  // });
  // return await _doUploadImage(resizedImage[0].data, filename);
};

const showErrorToast = (
  msg = "Something went wrong. Please try again later."
) => {
  toast(msg, {
    autoClose: 3000,
    type: toast.TYPE.ERROR,
    hideProgressBar: false,
  });
};

const groupBy = (xs, key) => {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const formatMoney = (number) => {
  return parseInt(number)
    .toLocaleString("en-US", { style: "currency", currency: "USD" })
    .split(".")[0];
};

export const AppHelper = {
  uploadImage,
  showErrorToast,
  groupBy,
  formatMoney,
};
